{
  "id": "materialShelf",
  "name": "Material Shelf",
  "builds": "upgrade",
  "category": "shopFurniture",
  "note": "Two planks across the stretchers — that's the whole build.",
  "skill": "shopFurniture",
  "duration": 20,
  "offeredBy": "bench",
  "fastener": "nails",
  "widthIn": 48,
  "heightIn": 24,
  "slots": [
    {
      "id": "plank-0",
      "role": "plank",
      "part": {
        "widthIn": 4,
        "lengthIn": 48,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [1, 2]
      },
      "xIn": 24,
      "yIn": 8,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "plank-1",
      "role": "plank",
      "part": {
        "widthIn": 4,
        "lengthIn": 48,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [1, 2]
      },
      "xIn": 24,
      "yIn": 16,
      "angleDeg": 90,
      "zIn": 0
    }
  ],
  "fasteners": []
}
